import { useQuery } from '@tanstack/react-query';
import axios from 'axios';
import { useSelector } from 'react-redux';
import { selectGroupGuid } from '../../../slices/commonSelectors';
import config from '../../../constants/apiConfig';

export type ResourceSet = {
  id: string;
  resource_set_id: string;
  name: string;
  kind: string;
  type: string;
  quantity: number;
  status: string;
  description: string;
  user_guid: string;
  timestamp: Date;
  version: number;
  incidents: string[];
  archived?: boolean;
};

export const keys = {
  all: ['resourceSets'],
  list: (groupId: string) => [...keys.all, groupId],
};

export const useResourceSets = () => {
  const group_guid = useSelector(selectGroupGuid);

  return useQuery({
    queryKey: keys.list(group_guid),
    queryFn: async () => {
      const resp = await axios.get<ResourceSet[]>(
        `${config.apiGateway.ics_resource_sets}/${group_guid}`
      );
      return resp.data.filter(
        (resource: ResourceSet) => resource.status !== 'archived'
      );
    },
  });
};
